const RoundClose = ({ color }) => {
  return (
    <svg
      className="size-24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "#1E4387"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m15 9-6 6" />
      <path d="m9 9 6 6" />
    </svg>
  );
};

export default RoundClose;
